<template>
  <div class="flex relative dragSlideLeftCont" ref="dragElContainer">
    <button ref="dragElHandle" class="min-w-screen flex-[0_0_100vw] h-[4.41rem] px-4" :class="[buttonClass]">
      <slot></slot>
    </button>

    <div ref="buttonActionCont" class="flex items-center gap-3">
      <button v-if="hasEditBtn" @click="() => emitAction('edit')"
        class="bg-blue/20  w-[2.64rem] h-[2.64rem] rounded-full p-2">
        <church-icon class="!text-blue" :icon="'pencil'" />
      </button>

      <button v-if="hasDeleteBtn" @click="() => emitAction('delete')"
        class="bg-red/20 text-red w-[2.64rem] h-[2.64rem] rounded-full p-2">
        <church-icon class="!text-red" :icon="'trash'" />
      </button>
    </div>
  </div>
</template>

<script setup>
/* Utils */
import DragHorizontal from '@/helpers/dragHorizontal'
import { onMounted, ref, defineProps, defineEmits } from 'vue'

/* Props */
const props = defineProps({
  readonly: { type: Boolean, default: false },
  hasEditBtn: { type: Boolean, default: true },
  hasDeleteBtn: { type: Boolean, default: true },
  editBtnIcon: { type: String, default: 'pencil-square' },
  deleteBtnIcon: { type: String, default: 'trash' },
  buttonClass: { type: String, default: '' },
})

/* States */
const dragElContainer = ref()
const dragElHandle = ref()
const buttonActionCont = ref()
const isReveal = ref(false)

/*  =========== EMITS ======= */
const emit = defineEmits(['edit', 'delete'])


/* ========== METHODS ======== */
/**
 * Emit action
 * @param {String} action
 */
const emitAction = (action) => {
  emit(action)

  dragElContainer.value.style.left = null
}

/* Onload */
onMounted(() => {
  /* Init drag show horizontal */
  if (!props.readonly) {
    DragHorizontal.init(dragElContainer.value, {
      handle: dragElHandle.value,
      threshold: buttonActionCont.value.clientWidth + 30,
      callback: (showState) => {
        isReveal.value = showState
      }
    })
  }
})
</script>
